import React from "react";
import { GamePreview } from "../../../../common/components/GamePreview";
import landingIphone1 from "../../../../assets/img/landing-page/landingIphone1.png";
import landingIphone2 from "../../../../assets/img/landing-page/landingIphone2.png";
import landingSquares from "../../../../assets/img/landing-page/landing_squares.png";
import landingBg1Gold from "../../../../assets/img/landing-page/landing_bg_1_gold.png";
import landingBg2Green from "../../../../assets/img/landing-page/landing_bg_2_green.png";
import landingStartGold from "../../../../assets/img/landing-page/landing_star_gold.png";

import { TrainTheFunMobile } from "./TrainTheFunMobile";

import { LandingStoreButtons } from "./LandingStoreButtons";

import { LandingPlayNowButton } from "./LandingPlayNowButton";

import {
  iphone2divStyle,
  landingBg1GoldStyle,
  IphoneMocksStyled,
} from "./appMocks.styles";

interface IPhoneMocksProps {
  handlePlayNowClick: () => void;
}

export const IPhoneMocks: React.FC<IPhoneMocksProps> = ({
  handlePlayNowClick,
}) => {
  return (
    <IphoneMocksStyled>
      <div className="iphone1div">
        <img src={landingIphone1} alt="iPhone1" className="iPhone1" />
      </div>
      <div className="iphone2div" style={iphone2divStyle}>
        <TrainTheFunMobile />
        <div className="relative">
          <div
            className="game-preview-container"
            onClick={() => handlePlayNowClick()}
          >
            <GamePreview />
          </div>
          <div className="icons_and_backgrounds">
            <img src={landingIphone2} alt="iPhone2" className="iPhone2" />
            {/* <div className="middle-row">
              <img
                src={landingSquares}
                alt=""
                className="landingSquares_small"
              />
            </div>
            <img
              src={landingStartGold}
              // style={{ marginRight: "-100px" }}
              alt=""
              className="landingStartGold_new"
            /> */}

            {/* <img src={landingBg2Green} alt="" className="bottomgreen_new" />
            <img
              src={landingBg1Gold}
              style={landingBg1GoldStyle}
              alt=""
              className="landingBg1Gold_new"
            /> */}
          </div>
        </div>
        <div className="landing--play-btn xs-shrink-0 w-100 flex-col hidden xs-flex xs-justify-center  xs-mx-auto">
          <LandingStoreButtons />
        </div>
        <LandingPlayNowButton handlePlayNowClick={handlePlayNowClick} />
      </div>
    </IphoneMocksStyled>
  );
};
